export default __webpack_public_path__ + "static/media/Logo_horizontal_laranja.b53fb061.png";